<div class="modal-header">
  <h3 class="modal-title">
    Repetir Actividad
    <!-- <span class="date-title">
    {{currentDate.substring(0,10).split('-').reverse().toString().replace(',','/').replace(',','/')}}
  </span> -->
</h3>
<button type="button" class="close text-primary" aria-label="Close"
  (click)="activeModal.dismiss('Cross click')">
  <i class="fas fa-times-circle"></i>
</button>
</div>
<form (ngSubmit)="submitReminder()">
  <div class="modal-body">
    <div class="form-group">
      <div class="row">
        <div class="col-sm-12">
          <div class="calendar-el">
            <div class="input-group">
              <div class="style-button text-calendar">
                <label for="" class="text-form"> Inicio: </label>
              </div>
              <input
                class="form-control style-datepicker"
                placeholder="Seleccionar fecha"
                name="begin"
                [(ngModel)]="model1"
                (ngModelChange)="changeMinDate($event)"
                #begin="ngModel"
                [minDate]="mindateStart"
                ngbDatepicker #d1="ngbDatepicker"
                [readonly]="true"
                >
              <div class="input-group-append style-button">
                <button class="btn fas fa-calendar-alt bt" (click)="d1.toggle()" type="button"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <select
        class="form-control style-select"
        [(ngModel)]="typeCalendar"
        [ngModelOptions]="{standalone: true}"
        (ngModelChange)="onSelectOption1($event)"
        >
        @for (calendar1 of calendars1; track calendar1) {
          <option [ngValue]="calendar1" [selected]="true">{{calendar1}}</option>
        }
      </select>
    </div>
    @if (listDays) {
      <div class="form-group">
        <div class="row">
          <div class="col-md-12">
            <ul class="checkbox-items">
              @for (item of checkboxesDataList; track item) {
                <li class="list">
                  <input type="checkbox" name="{{item.id}}" class="position-static"  [(ngModel)]="item.isChecked" value="{{item.id}}" (change)="changeSelection()">
                  <span class="label-days">{{item.label}}</span>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    }
    @if (listMonth) {
      <div class="form-group">
        <div class="row">
          <div class="col-md-1 pl-3 pt-2 pr-0 text-right">El</div>
          <div class="col-md-5 pl-2">
            <select
              [(ngModel)]="monthChosenOrdinal"
              [ngModelOptions]="{standalone: true}"
              (ngModelChange)="onSelectOption2($event)"
              class="form-control style-select-number"
              >
              @for (ordinal of ordinals; track ordinal) {
                <option [ngValue]="ordinal">{{ordinal}}</option>
              }
            </select>
          </div>
          <div class="col-md-5 pl-1">
            <select
              [(ngModel)]="monthChosenDay"
              [ngModelOptions]="{standalone: true}"
              (ngModelChange)="onSelectOption3($event)"
              class="form-control style-select-days"
              >
              @for (day of days; track day) {
                <option [ngValue]="day">{{day}}</option>
              }
            </select>
          </div>
        </div>
      </div>
    }
    <div class="form-group">
      <div class="row">
        <div class="col-sm-12">
          <div class="calendar-el">
            <div class="input-group">
              <div class="style-button text-calendar pr-2">
                <label for="" class="text-form"> Fin: </label>
              </div>
              <input
                class="form-control style-datepicker"
                placeholder="Seleccionar fecha"
                name="end"
                [(ngModel)]="model2"
                #end="ngModel"
                [minDate]="mindate"
                ngbDatepicker #d2="ngbDatepicker"
                [readonly]="true"
                >
              <div class="input-group-append style-button">
                <button class="btn fas fa-calendar-alt bt" (click)="d2.toggle()" type="button"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (successMessage) {
      <div class="form-group">
        <div class="row">
          <div class="col-md-12">
            <ngb-alert class="mt-3" type="success" (close)="successMessage = ''">{{ successMessage }}</ngb-alert>
          </div>
        </div>
      </div>
    }
    @if (errorMessage) {
      <div class="form-group">
        <div class="row">
          <div class="col-md-12">
            <ngb-alert  class="mt-3" type="danger" (close)="errorMessage = ''">{{ errorMessage }}</ngb-alert>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-md-12 text-right">
        <button type="button" class="btn btn-outline-dark rounded-pill font-weight-bold" style="width: 120px;"
          (click)="activeModal.close('Close click')">
          Cerrar
        </button>
        <button type="submit"
          class="btn btn-outline-primary  rounded-pill text-dark  font-weight-bold mr-2"
          style="width: 120px;"
          >
          @if (loading) {
            <div>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Cargando...
            </div>
          }
          @if (!loading) {
            <span>
              Crear
            </span>
          }
        </button>
      </div>
    </div>
  </div>
</form>


